import React, { useState } from 'react';
import { Dialog, DialogContent } from 'shared/ui/Dialog';
import { Btn } from 'shared/ui/Btn';
import { useQuoteActionsCtx } from 'shared/state/quoteActionsContext';

/** V2 restyle of the Phase 0b SaveQuoteDialog. Same rules: nothing saves
 *  without a non-whitespace description, Enter saves, the field clears on close. */
export function SaveDialog() {
  const { saveQuote, showSaveDialog, setShowSaveDialog } = useQuoteActionsCtx();
  const [description, setDescription] = useState('');
  const canSave = description.trim().length > 0;

  const close = () => { setDescription(''); setShowSaveDialog(false); };
  const save = () => { if (!canSave) return; saveQuote(description); close(); };

  return (
    <Dialog open={showSaveDialog} onOpenChange={(next) => { if (!next) close(); }}>
      <DialogContent
        title="Save configuration"
        description="The description is what you will see in the Load list."
        // Classic SaveQuoteDialog.jsx had no scrim-click handler at all, so a
        // mis-click cost nothing. Radix's modal Dialog closes on any outside
        // pointer-down by default, which would silently clear a typed
        // description on a stray click — only guard it while there's text to
        // lose; an empty field may still close freely (Escape and Cancel are
        // untouched either way).
        onPointerDownOutside={(e) => { if (canSave) e.preventDefault(); }}
      >
        <input
          aria-label="Quote description"
          autoFocus
          value={description}
          placeholder="Enter quote description"
          onChange={(e) => setDescription(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') save(); }}
          className="h-9 w-full rounded-[var(--radius-2)] border border-hairline/30 bg-surface px-3 font-body text-sm text-ink focus:outline-none focus:ring-2 focus:ring-brand/60"
        />
        <div className="mt-4 flex justify-end gap-2">
          <Btn variant="neutral" onClick={close}>Cancel</Btn>
          <Btn variant="contained" disabled={!canSave} onClick={save}>Save</Btn>
        </div>
      </DialogContent>
    </Dialog>
  );
}
